import React, { Fragment } from 'react';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.jpeg'





const PrivacyPage = () => {
    return (
        <Fragment>
            <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                            col2={'col-lg-2 col-md-4 col-6'}
                            col3={'col-lg-7 col-md-1 col-1'}
                            col4={'col-lg-3 col-md-4 col-2'} />
            <PageTitle pageTitle={''} pagesub={'Privacy Policy'} />
            <ScrollTextAnimation />
            <section className="pf-terms-section section-padding pt-0">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="pf-terms-wrap">
                                {/* <div className="pf-terms-img">
                                    <img src={Privci1} alt="" />
                                </div> */}
                                <div className="pf-terms-text">
    <h2>Privacy Policy</h2>

    <p>
        At <strong>YV Reddy Associates</strong>, we value your trust and are committed to protecting
        your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard
        your information when you visit our website or engage with our architectural, interior,
        and turnkey contracting services.
    </p>

    <p>
        By accessing or using our website, you agree to the terms of this Privacy Policy. If you do
        not agree with the terms outlined here, we request that you discontinue using our website.
    </p>

    <h3>Information We Collect</h3>
    <p>
        We may collect personal and non-personal information in various ways, including when you
        visit our website, submit enquiry forms, request consultations, or communicate with us
        directly.
    </p>

    <ul>
        <li><strong>Personal Information:</strong> Name, email address, phone number, company name,
            project details, and any other information you voluntarily provide.</li>
        <li><strong>Technical Information:</strong> IP address, browser type, device information,
            operating system, and website usage data.</li>
        <li><strong>Project-Related Information:</strong> Design requirements, site details, and
            specifications shared for consultation or project execution.</li>
    </ul>

    <h3>How We Use Your Information</h3>
    <p>
        The information collected is used strictly for professional and operational purposes,
        including but not limited to:
    </p>

    <ul>
        <li>Responding to enquiries, consultations, and project requests</li>
        <li>Providing architectural, interior, and turnkey contracting services</li>
        <li>Preparing proposals, drawings, and project documentation</li>
        <li>Improving website functionality and user experience</li>
        <li>Internal analysis, quality control, and service improvement</li>
        <li>Legal, regulatory, and contractual compliance</li>
    </ul>

    <h3>Information Sharing & Disclosure</h3>
    <p>
        YV Reddy Associates does not sell, trade, or rent your personal information to third parties.
        Information may be shared only under the following circumstances:
    </p>

    <ul>
        <li>With trusted consultants, contractors, or vendors involved in project execution</li>
        <li>When required by law, regulation, or legal process</li>
        <li>To protect our rights, safety, property, or professional interests</li>
        <li>With your explicit consent</li>
    </ul>

    <h3>Data Security</h3>
    <p>
        We implement appropriate technical and organizational security measures to protect your
        personal information from unauthorized access, alteration, disclosure, or destruction.
        While we strive to use commercially acceptable means to protect your data, no method of
        transmission over the internet is 100% secure.
    </p>

    <h3>Cookies & Website Analytics</h3>
    <p>
        Our website may use cookies and similar technologies to enhance browsing experience,
        analyze website traffic, and understand user behavior. You may choose to disable cookies
        through your browser settings; however, doing so may affect certain functionalities of the
        website.
    </p>

    <h3>Third-Party Links</h3>
    <p>
        Our website may contain links to third-party websites for reference or convenience. YV
        Reddy Associates is not responsible for the privacy practices or content of external sites.
        We encourage users to review the privacy policies of those websites before providing any
        personal information.
    </p>

    <h3>Professional Disclaimer</h3>
    <p>
        All architectural designs, drawings, concepts, and intellectual property shared on this
        website are for informational purposes only. Any reuse, reproduction, or distribution
        without prior written consent from YV Reddy Associates is strictly prohibited.
    </p>

    <h3>Your Rights</h3>
    <p>
        You have the right to request access, correction, or deletion of your personal information
        held by us, subject to applicable laws and professional obligations. Requests can be made
        by contacting us through the details provided on our website.
    </p>

    <h3>Updates to This Privacy Policy</h3>
    <p>
        YV Reddy Associates reserves the right to update or modify this Privacy Policy at any time
        without prior notice. Changes will be effective immediately upon posting on this page.
        Continued use of the website after updates constitutes acceptance of the revised policy.
    </p>

    <h3>Contact Information</h3>
    <p>
        If you have any questions or concerns regarding this Privacy Policy or our data practices,
        please contact us through the official communication channels listed on our website.
    </p>
</div>

                                {/* <div className="pf-faq-section">
                                    <h4>Frequently Ask Questions</h4>
                                    <div className="row">
                                        <div className="col-lg-12 col-md-12 col-12">
                                            <FAQAccordion/>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar /> 
        </Fragment>
    )
};
export default PrivacyPage;





